var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { mapGetters } from 'vuex';
import { CATEGORY, MENU_ITEMS } from '@/stores/defs';
import navigationMixin from '@Mixin/navigationMixin';
import alertMixin from '@Mixin/alertMixin';
import { isEmpty } from 'lodash';
;
var randomColor = require('randomcolor');
// TODO consolidate item related mixins
var menuItemMixin = {
    mixins: [
        navigationMixin,
        alertMixin,
    ],
    computed: __assign({}, mapGetters({
        getCategoryName: CATEGORY.GET_NAME,
        getCategoryForItem: CATEGORY.GET_CATEGORY_FOR_ITEM,
        getItem: MENU_ITEMS.GET_ITEM,
    }), { checkDisabled: function () {
            var item = this.item;
            if (item.outOfStock) {
                return true;
            }
            return false;
        },
        _itemName: function () {
            var item = this.item;
            return item.name;
        },
        _noOptions: function () {
            var item = this.item;
            var noOptions = isEmpty(item.optionIds);
            return noOptions;
        } }),
    methods: {
        handleClick: function () {
            if (this.checkDisabled) {
                this.alertWithMessage("Oops", "Sorry, the " + this._itemName + " is currently unavailable.");
                return;
            }
            var afterClick = this.afterClick;
            if (!this.click) {
                var route = this.getItemRoute(this.item);
                this._navigateToItem(route);
                afterClick();
                return;
            }
            this.click();
            afterClick();
        },
        menuItem_getItemColors: function (item, luminosity) {
            if (luminosity === void 0) { luminosity = 'dark'; }
            var itemName = item.name;
            var prepColor = item.prepColor || randomColor({
                seed: itemName,
            });
            var color = prepColor;
            var seededColor = randomColor({
                luminosity: luminosity,
                hue: prepColor,
                seed: itemName,
            });
            var topColor = randomColor({
                luminosity: luminosity,
                hue: 'monochrome',
                seed: itemName,
            });
            return {
                color: color,
                seededColor: seededColor,
                topColor: topColor,
            };
        },
        generateVanityName: function (name) {
            var hyphenate = name.replace(/\s+/g, '-');
            var removeCharacters = hyphenate.replace(/\.|\,|\'/g, '');
            return removeCharacters.toLowerCase();
        },
        getItemRoute: function (item) {
            var itemName = this.generateVanityName(item.name);
            var storedItem = this.getItem(item.id);
            if (!storedItem) {
                storedItem = this.getItem(item.parentAssetId);
            }
            if (!storedItem) {
                storedItem = this.getItem(itemName);
            }
            var categoryName = this.getCategoryForItem(storedItem.id);
            return {
                name: 'item-detail',
                params: {
                    name: itemName,
                    categoryId: categoryName,
                    item: item,
                    meta: {
                        route: this.$route,
                    },
                },
            };
        },
        loadImage: function () { },
    },
};
export default menuItemMixin;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/menuItemMixin.ts
// module id = 9utB
// module chunks = 18